import React, { Component } from 'react'
import onClickOutside from 'react-onclickoutside'
import { withRouter } from 'react-router'
import RecursiveElement from './RecursiveElement'

const SelectLi = ({ children, value, handleChange }) => {
  const handleClick = () => {
    handleChange(value)
  }
  return (
    <li onClick={handleClick}>
      {children}
    </li>
  )
}

class SelectDD extends Component {
  handleClickOutside = e => {
    this.props.handleToggle()
  }
  render() {
    return (
      <div className={this.props.className}>
        <div className="selectbox-selected" onClick={this.props.handleToggle}>{this.props.items && this.props.items.find(item => item.value === this.props.value).name}</div>
        <div className="selectbox-options">
          <ul>
            {this.props.items && this.props.items.map((item) => (
              <SelectLi key={item.value} value={item.value} handleChange={this.props.handleChange}>{item.name}</SelectLi>
            ))}
          </ul>
        </div>
      </div>
    )
  }
}

const SelectDDContainer = onClickOutside(SelectDD)

class SelectBox extends Component {
  constructor(props) {
    super(props)
    this.state = {
      toggle: false
    }
  }
  handleToggle = () => {
    this.setState({ toggle: !this.state.toggle })
  }
  handleChange = (value) => {
    this.setState({
      toggle: false
    })
    this.props.onChange(value)
  }
  render() {
    return (
      <SelectDDContainer className={`selectbox${this.state.toggle ? ' active' : ''}`} items={this.props.items} value={this.props.value} handleChange={this.handleChange} handleToggle={this.handleToggle} disableOnClickOutside={!this.state.toggle} />
    )
  }
}

class VCTtaTabs extends Component {
  constructor(props) {
    let tab
    if (props.location.hash && props.location.hash.indexOf('#tab-') === 0) {
      // eslint-disable-next-line
      tab = props.location.hash.replace('#tab-', '').replace(/[^0-9a-z\-]/g, '');
      if (!props.children.props.element.find(_tab => _tab.attribs['data-vc-tab-id'] === tab)) tab = undefined
    }

    super(props)
    this.state = {
      current: tab || (this.props.children && this.props.children.props.element[0].attribs['data-vc-tab-id'])
    }
  }
  handleClick = e => {
    this.setState({
      current: e.currentTarget.getAttribute('data-vc-tab-id')
    })
  }
  handleChange = value => {
    this.setState({
      current: value
    })
  }
  render() {
    return (
      <div className={`tabs${this.props.className?' '+this.props.className:''}`}>
        <ul className='tabmenu'>
        {this.props.children && this.props.children.props.element.map((element, key) => (
            <li className={`tabtitle${this.state.current === element.attribs['data-vc-tab-id'] ? ' active' : ''}`} key={key} data-vc-tab-id={element.attribs['data-vc-tab-id']} onClick={this.handleClick}>{element.attribs['data-vc-title']}</li>
          ))
        }
        </ul>
        <div className="mobile-select">
          <SelectBox
            items={this.props.children && this.props.children.props.element.map((element, key) => ({value: element.attribs['data-vc-tab-id'], name: element.attribs['data-vc-title'] }))}
            value={this.state.current}
            onChange={this.handleChange}
          />
        </div>
        {this.props.children && this.props.children.props.element.map((element, key) => {
          return (
            <RecursiveElement key={key} element={{
              ...element,
              attribs: {
                ...element.attribs,
                'data-vc-class': this.state.current === element.attribs['data-vc-tab-id'] ? element.attribs['data-vc-class'] ? element.attribs['data-vc-class'] + ' active' : 'active' : element.attribs['data-vc-class']
              }
            }} />
          // <div className={`tabcontent canHabeCustomClass${this.state.current === element.attribs['data-vc-tab-id'] ? ' active' : ''}`} key={key} data-vc-tab-id={element.attribs['data-vc-tab-id']}>
          //   <RecursiveElement element={element} />
          // </div>
        )})}
      </div>
    )
  }
}

export default withRouter(VCTtaTabs)



// WEBPACK FOOTER //
// ./src/components/VCTtaTabs.js